import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/AutoAcceptance/messages';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

type VetoApplicationPayload = {
  applicationId: number;
  vetoReason: string;
};

const vetoApplication = async ({
  applicationId,
  vetoReason,
}: VetoApplicationPayload) => {
  const body = {
    auto_acceptance_skipped_application: { veto_reason: vetoReason },
  };
  const { data } = await putRequest(
    API.PUT.vetoApplication(applicationId),
    body,
  );
  return data;
};

export const useVetoApplication = () => {
  const client = useQueryClient();

  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: vetoApplication,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS_COUNT],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CALENDAR_JOBS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOBS],
      });
      handleSuccess(formatMessage(messages.applicationVetoed));
    },
    onError: handleError,
  });
};
